import React from "react";

const TaglineMarquee = () => {
  return (
    <div className="tagline-marquee-container">
      <p className="tagline-marquee-text">
        🌸 Register with TheOmSaga for just Rs.99/- and contribute towards those in need of support 🌸
      </p>
    </div>
  );
};

export default TaglineMarquee;

